// validation.ts
import * as yup from 'yup';
import NumberConverter from '../../../helper/ConvertPersionNumberToEnglish';

export const validationSchema = yup.object().shape({
  code: yup
    .string()

    .transform((value) => {
      if (!value) return value;
      return NumberConverter.toEnglishNumber(value);
    })
    .matches(/^\d{6}$/, 'کد باید6 رقم باشد')
    .required('لطفاً کد تایید را وارد کنید'),
});
